import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const Archive = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ size, variant, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16">
    <path
      d="M3.83333 5.33334H13.1667M3.83333 5.33334C3.47971 5.33334 3.14057 5.19286 2.89052 4.94281C2.64048 4.69277 2.5 4.35363 2.5 4.00001C2.5 3.64638 2.64048 3.30724 2.89052 3.0572C3.14057 2.80715 3.47971 2.66667 3.83333 2.66667H13.1667C13.5203 2.66667 13.8594 2.80715 14.1095 3.0572C14.3595 3.30724 14.5 3.64638 14.5 4.00001C14.5 4.35363 14.3595 4.69277 14.1095 4.94281C13.8594 5.19286 13.5203 5.33334 13.1667 5.33334M3.83333 5.33334V12C3.83333 12.3536 3.97381 12.6928 4.22386 12.9428C4.47391 13.1929 4.81304 13.3333 5.16667 13.3333H11.8333C12.187 13.3333 12.5261 13.1929 12.7761 12.9428C13.0262 12.6928 13.1667 12.3536 13.1667 12V5.33334M7.16667 8H9.83333"
      stroke="#010B3B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Archive;
